import {getSelectedPaymentOptionType} from '../selectors';
import getSelectedPaymentOptionTypeForGenericBillingAddress
from './getSelectedPaymentOptionTypeForGenericBillingAddress';

export default (state) => {
  const paymentOptionToLookUp = getSelectedPaymentOptionTypeForGenericBillingAddress(state);
  const paymentOptionType = getSelectedPaymentOptionType(state)?.toLowerCase();
  const addressState = state.address;
  
  const genericBillingAddressState = addressState.genericBillingAddress?.[paymentOptionToLookUp];
  
  if (paymentOptionType) {
    if (paymentOptionType === 'new_credit_card') {
      return !addressState.isUseDeliveryAddressForBilling;
    }
    if (genericBillingAddressState) {
      return !genericBillingAddressState.useShippingAddress;
    } return false;
  }
};
